import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCheckSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 7.70207L6.66667 10.3687L12 5.0354", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCheckSmall);
const Memo = memo(ForwardRef);
export default Memo;
